import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../auth/guards';
import { ChangesNotSavedGuard } from '../shared/changes-not-saved';
import { AccountComponent } from './account.component';
import { PersonalInformationComponent } from './pages';

const routes: Routes = [
    {
        path: ':clientCode/account',
        component: AccountComponent,
        canActivate: [AuthGuard],
        children: [
            {
                path: 'personal-information',
                component: PersonalInformationComponent,
                canDeactivate: [ChangesNotSavedGuard]
            },
            { path: '', redirectTo: 'personal-information', pathMatch: 'full' }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class AccountRoutingModule {}
